import React from 'react';
import Info from './Info';

const left = () => {
    return (
        <div className="lg:w-4/12 w-full lg:mr-3 lg:mb-0 mb-3">
            <Info/>
        </div>
    );
};

export default left;